import { Hand, Sparkles, Sunrise } from "lucide-react";
import { VALORES } from "@/constants/site";
import { Reveal } from "@/components/Reveal";

const ICONOS = { hand: Hand, sparkles: Sparkles, sunrise: Sunrise };

export const Calidad = () => (
  <section data-testid="quality-section" className="py-20 sm:py-28 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
      <div className="relative overflow-hidden rounded-[2.5rem] bg-chocolate px-6 py-16 text-crema sm:px-12 lg:px-16 lg:py-20">
        <div
          aria-hidden
          className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-cafe/40 blur-3xl"
        />
        <Reveal>
          <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-crema/60">
            <span aria-hidden className="h-px w-9 bg-crema/40" />
            Calidad
          </p>
          <h2 className="mt-6 max-w-2xl font-serif text-3xl leading-[1.14] tracking-tight sm:text-4xl lg:text-[2.9rem]">
            La diferencia está{" "}
            <em className="font-garamond font-medium italic text-arena">
              en los detalles.
            </em>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-10 md:grid-cols-3">
          {VALORES.map((v, i) => {
            const Icon = ICONOS[v.icon];
            return (
              <Reveal
                key={v.titulo}
                delay={i * 0.12}
                className="border-t border-crema/20 pt-8"
                data-testid={`quality-value-${i + 1}`}
              >
                <Icon className="h-6 w-6 text-dorado" strokeWidth={1.6} />
                <h3 className="mt-5 font-serif text-xl sm:text-2xl">{v.titulo}</h3>
                <p className="mt-3 text-sm leading-relaxed text-crema/70">{v.descripcion}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

export default Calidad;
